import { List } from '@repo/ui';

import { LOGO_EXPERTS } from '@/lib/constants/content-section';

export const RespondentCard = ({
  name,
  organization,
  className,
  leadingElementSize = 'small'
}: {
  name?: string;
  organization?: string;
  className?: string;
  leadingElementSize?: 'small' | 'large';
}) => {
  const logoUrl: string | undefined = organization ? LOGO_EXPERTS[organization] : undefined;
  return (
    <List
      size={'xsmall'}
      leadingElement={logoUrl && <img src={logoUrl} className={`${leadingElementSize === 'small' ? 'w-6' : 'w-10 h-10'}`} alt={organization} />}
      title={name ? `${name}가 검증한 답변이에요.` : '세나가 답변했어요'}
      description={organization ?? 'AI의 답변은 완벽하지 않을 수 있으니 확인 후 활용하세요.'}
      className={className}
      role={'contentinfo'}
    />
  );
};
